import imageDefault from "../img/Rectangle-1434-2.png";
import backGround from "../img/Rectangle-1434.png";
import imageTableService from "../img/Rectangle-113.png";
export class ImageConfig {
  static IMAGE_TABLE_SERVICE = imageTableService;
  static IMAGE_DEFAULT_SERVICE = imageDefault;
  static BACKGROUND_DEFAULT_SERVICE = backGround;
}
